import {btn_icon_sm, svg_circ, svg_sm, btn_icon_md, btn_icon_lg, svg_md} from '../../styleGuide';


const svg = {...svg_circ};

export default {
  button_sm: {
    ...btn_icon_sm,
  },
  icon_sm: {
    ...svg,
    ...svg_sm,
  },
  button_md: {
    ...btn_icon_md,
  },
  icon_md: {
    ...svg,
    ...svg_sm,
    marginRight: '.8rem'
  },
  button_lg: {
    ...btn_icon_lg,
  },
  icon_lg: {
    ...svg,
    ...svg_md,
    marginRight: '1rem'
  }
}
